import React, { useState } from "react";
import { supportTickets as initialTickets } from "../../../data/mockData";
import Card from "../../../components/ui/Card";
import Button from "../../../components/ui/Button";
import Input from "../../../components/ui/Input";
import TicketDetailModal from "../components/TicketDetailModal"; // Import the new modal
import { Search } from "lucide-react";

const StatusBadge = ({ status }) => {
  const statusClasses = {
    Open: "bg-red-100 text-red-700",
    Pending: "bg-yellow-100 text-yellow-700",
    Closed: "bg-green-100 text-green-700",
  };
  return (
    <span
      className={`px-2 py-1 text-xs font-semibold rounded-full ${statusClasses[status]}`}
    >
      {status}
    </span>
  );
};

const SupportTicketsPage = () => {
  const [tickets, setTickets] = useState(initialTickets);
  const [selectedTicket, setSelectedTicket] = useState(null);

  const handleTicketClick = (ticket) => {
    setSelectedTicket(ticket);
  };

  const handleCloseModal = () => {
    setSelectedTicket(null);
  };

  const handleReply = (ticketId, message) => {
    const newReply = { from: "Adnaki Support", message };
    setTickets((currentTickets) =>
      currentTickets.map((ticket) =>
        ticket.id === ticketId
          ? {
              ...ticket,
              conversation: [...ticket.conversation, newReply],
              status: "Pending",
              lastUpdate: "Just now",
            }
          : ticket
      )
    );
    // In a real app, you might close the modal or just see the reply appear.
    // For the prototype, we'll update the selected ticket in the modal as well.
    setSelectedTicket((prev) => ({
      ...prev,
      conversation: [...prev.conversation, newReply],
    }));
  };
  return (
    <>
      <div>
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="text-3xl font-bold text-slate-800">
              Support Tickets
            </h1>
            <p className="text-slate-500 mt-1">
              Manage and resolve user-reported issues.
            </p>
          </div>
          <Button variant="primary" onClick={() => alert("Create Ticket modal coming soon!")}>
            <Search size={16} className="mr-2" />
            Create Ticket
          </Button>
        </div>

        <Card>
          <div className="flex items-center justify-between mb-4">
            <div className="flex space-x-2">
              <Button variant="primary" size="sm">
                All Tickets
              </Button>
              <Button variant="ghost" size="sm">
                Open
              </Button>
              <Button variant="ghost" size="sm">
                Closed
              </Button>
            </div>
            <div className="relative w-64">
              <Input placeholder="Search tickets..." className="pl-10" />
              <Search
                size={20}
                className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"
              />
            </div>
          </div>

          {/* Tickets List */}
          <div className="overflow-x-auto">
            <table className="min-w-full text-sm">
              <thead className="bg-slate-50">
                <tr>
                  <th className="p-3 text-left font-semibold text-slate-600">
                    Subject
                  </th>
                  <th className="p-3 text-left font-semibold text-slate-600">
                    User
                  </th>
                  <th className="p-3 text-left font-semibold text-slate-600">
                    Status
                  </th>
                  <th className="p-3 text-left font-semibold text-slate-600">
                    Last Update
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-200">
                {tickets.map((ticket) => (
                  <tr
                    key={ticket.id}
                    className="hover:bg-slate-50 cursor-pointer"
                    onClick={() => handleTicketClick(ticket)}
                  >
                    <td className="p-3 font-medium text-slate-800">
                      {ticket.subject}
                    </td>
                    <td className="p-3 text-slate-600">{ticket.user}</td>
                    <td className="p-3">
                      <StatusBadge status={ticket.status} />
                    </td>
                    <td className="p-3 text-slate-500">{ticket.lastUpdate}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Card>
      </div>
      <TicketDetailModal
        isOpen={!!selectedTicket}
        onClose={handleCloseModal}
        ticket={selectedTicket}
        onReply={handleReply}
      />
    </>
  );
};

export default SupportTicketsPage;
